import { AxiosResponse } from "axios";
import { Action } from "redux-saga";
import { call, CallEffect, PutEffect } from "redux-saga/effects";
import createAccount from "../account/create";
import { clearString, getFirstAndLastName, getFormattedCart } from "../../../utils/functions";
import api from "../../../settings/api";
import apiPCI from "../../../settings/apiPCI";


export interface Fetch {
    document: string;
    name: string;
    email: string;
    phone: string;
    address: {
        zipcode: string;
        streetName: string;
        neighbor: string;
        addressStreet: string;
        number: string;
        complement: string;
        city: string;
        state: string;
        stateCode: string;
    };
    visitorId: string;
    callback: (success: boolean, errorMessage?: string) => void;
}

export interface PaymentCardAction {
    type: string;
    payload: Fetch;
}

export default function* paymentCard({
    payload,
}: PaymentCardAction): Generator<
    CallEffect<unknown> | PutEffect<Action>,
    void,
    AxiosResponse
> {
    try {

        const account: unknown = yield call(createAccount, {
            type: "",
            payload: {
                document: payload.document,
                name: payload.name,
                email: payload.email,
                phone: payload.phone,
            }
        });

        const uriPCI = "/api/v1/tokenizing";
        const responsePCI = yield call(apiPCI.post, uriPCI, {
            // @ts-expect-error sagas types
            dataToToken: clearString(payload?.card?.cardNumber),
        });

        const uriBrands = "/v1/financeiro/bandeiras";
        const responseBrands = yield call(api.get, uriBrands);

        const {
            total,
            selected,
        } = getFormattedCart({
            // @ts-expect-error sagas types
            debts: payload?.debts,
            // @ts-expect-error sagas types
            cart: payload?.cart,
        });

        const brand = responseBrands?.data?.listaBandeiraCartao?.find((item: {
            descricaoBandeira: string;
        }) => item?.descricaoBandeira === responsePCI?.data?.additionalInformation?.brand?.name);

        const { firstName, lastName } = getFirstAndLastName(payload.name);

        const responseValidate = yield call(api.post, `/v1/payments/credit-card/validate`, {
            creditCardData: {
                buyerInformation: {
                    document: clearString(payload.document),
                    // @ts-expect-error sagas types
                    nrc: account?.customerId
                },
                deviceInformation: {
                    fingerprintSessionId: payload.visitorId,
                },
                orderInformation: {
                    billTo: {
                        country: "BR",
                        email: payload.email,
                        firstName: firstName,
                        lastName: lastName,
                        phoneNumber: clearString(payload.phone),
                    },
                    totalAmount: Number(Number(total)?.toFixed(2))
                },
                paymentInformation: {
                    card: {
                        cardIdentifier: brand?.codigoBandeira,
                        // @ts-expect-error sagas types
                        expirationMonth: payload?.card?.cardExpiration?.split('/')?.[0],
                        // @ts-expect-error sagas types
                        expirationYear: payload?.card?.cardExpiration?.split('/')?.[1],
                        number: responsePCI?.data?.token
                    }
                }
            },
        });

        const uriMethods = `/v1/payments/methods`;
        const responseMethods = yield call(api.get, uriMethods);

        const method = responseMethods?.data?.data?.find((item: {
            method: string
        }) => item.method === "credit-card");

        const body = {
            document: clearString(payload.document),
            // @ts-expect-error sagas types
            requestId: payload?.requestId,
            // @ts-expect-error sagas types
            customerIdentification: account?.customerId,
            // @ts-expect-error sagas types
            accountIdentification: account?.accountId,
            paymentValue: Number(Number(total)?.toFixed(2)),
            // @ts-expect-error sagas types
            licensePlate: clearString(payload?.plate?.toUpperCase()),
            emissionChannel: method?.code,
            tollPassages: selected,
            creditCardNumber: responsePCI?.data?.token,
            // @ts-expect-error sagas types
            creditCardOwner: payload?.card?.cardName,
            cardIdentifier: brand?.codigoBandeira,
            // @ts-expect-error sagas types
            monthDueDate: Number(payload?.card?.cardExpiration?.split('/')?.[0]),
            // @ts-expect-error sagas types
            yearDueDate: Number(payload?.card?.cardExpiration?.split('/')?.[1]),
            creditCardValidationToken: responseValidate?.data?.data?.validationToken,
            email: payload.email,
            phoneNumber: clearString(payload.phone),
            deviceInformation: {
                fingerprintSessionId: payload.visitorId
            }
        };

        const response = yield call(api.post, `/v1/payments/credit-card`, body);

        if (response?.data?.idTransaction) {
            yield call(payload.callback, true);
        } else {
            yield call(payload.callback, false, "error");
        }

    } catch (error) {
        yield call(payload.callback, false, "timeout");
    }
}